import { render, staticRenderFns } from "./search_new_screen.vue?vue&type=template&id=9bb64728&scoped=true&"
import script from "./search_new_screen.vue?vue&type=script&lang=ts&"
export * from "./search_new_screen.vue?vue&type=script&lang=ts&"
import style0 from "./search_new_screen.vue?vue&type=style&index=0&id=9bb64728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb64728",
  null
  
)

export default component.exports